/* tslint:disable */
/* eslint-disable */
/**
 * Localization service API
 * Service for localization Origin messages
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  L10nBatchRequestDto,
  L10nTextBatchResponseDto,
  L10nTextResponseDto,
  ListOfLocalizedTextsResponseDto,
  SaveLocalizedTextRequest,
} from '../models/index';
import {
    L10nBatchRequestDtoFromJSON,
    L10nBatchRequestDtoToJSON,
    L10nTextBatchResponseDtoFromJSON,
    L10nTextBatchResponseDtoToJSON,
    L10nTextResponseDtoFromJSON,
    L10nTextResponseDtoToJSON,
    ListOfLocalizedTextsResponseDtoFromJSON,
    ListOfLocalizedTextsResponseDtoToJSON,
    SaveLocalizedTextRequestFromJSON,
    SaveLocalizedTextRequestToJSON,
} from '../models/index';

export interface DeleteLocalizedTextRequest {
    symbolicTextId?: string;
    lang?: string;
}

export interface FindListOfTextsRequest {
    lang?: string;
    scope?: string;
}

export interface GetLocalizedTextRequest {
    symbolicTextId?: string;
    lang?: string;
}

export interface GetLocalizedTextBatchForUserRequest {
    l10nBatchRequestDto: L10nBatchRequestDto;
    user?: string;
    l10nId?: string;
}

export interface GetLocalizedTextForUserRequest {
    symbolicTextId?: string;
    user?: string;
    l10nId?: string;
}

export interface SaveLocalizedTextOperationRequest {
    saveLocalizedTextRequest: SaveLocalizedTextRequest;
    symbolicTextId?: string;
    lang?: string;
}

/**
 * 
 */
export class L10nControllerApi extends runtime.BaseAPI {

    /**
     * Deletes localized texts. Make sure that you remove the localized text from DB seeding too
     * Deletes specified localized text by its symbolicTextId and lang
     */
    async deleteLocalizedTextRaw(requestParameters: DeleteLocalizedTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        if (requestParameters['symbolicTextId'] != null) {
            queryParameters['symbolic-text-id'] = requestParameters['symbolicTextId'];
        }

        if (requestParameters['lang'] != null) {
            queryParameters['lang'] = requestParameters['lang'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/l10n/localized-text`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Deletes localized texts. Make sure that you remove the localized text from DB seeding too
     * Deletes specified localized text by its symbolicTextId and lang
     */
    async deleteLocalizedText(requestParameters: DeleteLocalizedTextRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.deleteLocalizedTextRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns all localized text messages used in UI. This endpoint is called by UI at startup for caching. Does not return email notifications - only messages used by UI
     * Get localized text for a lang
     */
    async findListOfTextsRaw(requestParameters: FindListOfTextsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListOfLocalizedTextsResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['lang'] != null) {
            queryParameters['lang'] = requestParameters['lang'];
        }

        if (requestParameters['scope'] != null) {
            queryParameters['scope'] = requestParameters['scope'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/l10n/localized-text/ui`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListOfLocalizedTextsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns all localized text messages used in UI. This endpoint is called by UI at startup for caching. Does not return email notifications - only messages used by UI
     * Get localized text for a lang
     */
    async findListOfTexts(requestParameters: FindListOfTextsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListOfLocalizedTextsResponseDto> {
        const response = await this.findListOfTextsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Use internal endpoint instead
     * Get localized text by symbolicTextId and its lang
     * @deprecated
     */
    async getLocalizedTextRaw(requestParameters: GetLocalizedTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<L10nTextResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['symbolicTextId'] != null) {
            queryParameters['symbolic-text-id'] = requestParameters['symbolicTextId'];
        }

        if (requestParameters['lang'] != null) {
            queryParameters['lang'] = requestParameters['lang'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/l10n/localized-text`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => L10nTextResponseDtoFromJSON(jsonValue));
    }

    /**
     * Use internal endpoint instead
     * Get localized text by symbolicTextId and its lang
     * @deprecated
     */
    async getLocalizedText(requestParameters: GetLocalizedTextRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<L10nTextResponseDto> {
        const response = await this.getLocalizedTextRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Use internal endpoint instead
     * Get all localized texts by symbolicTextIds
     * @deprecated
     */
    async getLocalizedTextBatchForUserRaw(requestParameters: GetLocalizedTextBatchForUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<L10nTextBatchResponseDto>> {
        if (requestParameters['l10nBatchRequestDto'] == null) {
            throw new runtime.RequiredError(
                'l10nBatchRequestDto',
                'Required parameter "l10nBatchRequestDto" was null or undefined when calling getLocalizedTextBatchForUser().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['user'] != null) {
            queryParameters['user'] = requestParameters['user'];
        }

        if (requestParameters['l10nId'] != null) {
            queryParameters['l10nId'] = requestParameters['l10nId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/l10n/localized-text/user/list`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: L10nBatchRequestDtoToJSON(requestParameters['l10nBatchRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => L10nTextBatchResponseDtoFromJSON(jsonValue));
    }

    /**
     * Use internal endpoint instead
     * Get all localized texts by symbolicTextIds
     * @deprecated
     */
    async getLocalizedTextBatchForUser(requestParameters: GetLocalizedTextBatchForUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<L10nTextBatchResponseDto> {
        const response = await this.getLocalizedTextBatchForUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Use internal endpoint instead
     * Get localized text by symbolicTextId for user or org
     * @deprecated
     */
    async getLocalizedTextForUserRaw(requestParameters: GetLocalizedTextForUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<L10nTextResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['symbolicTextId'] != null) {
            queryParameters['symbolic-text-id'] = requestParameters['symbolicTextId'];
        }

        if (requestParameters['user'] != null) {
            queryParameters['user'] = requestParameters['user'];
        }

        if (requestParameters['l10nId'] != null) {
            queryParameters['l10nId'] = requestParameters['l10nId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/l10n/localized-text/user`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => L10nTextResponseDtoFromJSON(jsonValue));
    }

    /**
     * Use internal endpoint instead
     * Get localized text by symbolicTextId for user or org
     * @deprecated
     */
    async getLocalizedTextForUser(requestParameters: GetLocalizedTextForUserRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<L10nTextResponseDto> {
        const response = await this.getLocalizedTextForUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates new localized texts. Usually not needed - all localized texts should be added to DB while seeding
     * Put new localized text with its symbolicTextId and lang
     */
    async saveLocalizedTextRaw(requestParameters: SaveLocalizedTextOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['saveLocalizedTextRequest'] == null) {
            throw new runtime.RequiredError(
                'saveLocalizedTextRequest',
                'Required parameter "saveLocalizedTextRequest" was null or undefined when calling saveLocalizedText().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['symbolicTextId'] != null) {
            queryParameters['symbolic-text-id'] = requestParameters['symbolicTextId'];
        }

        if (requestParameters['lang'] != null) {
            queryParameters['lang'] = requestParameters['lang'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/l10n/localized-text`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SaveLocalizedTextRequestToJSON(requestParameters['saveLocalizedTextRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Creates new localized texts. Usually not needed - all localized texts should be added to DB while seeding
     * Put new localized text with its symbolicTextId and lang
     */
    async saveLocalizedText(requestParameters: SaveLocalizedTextOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.saveLocalizedTextRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
